import React from 'react';
import { useTranslation } from 'react-i18next';

interface SubTopNavigationBarProps {
  testId?: string;
  className?: string;
  selectedIndex?: number;
  menus?: Array<{ text: string; context: string }>;
  setNavigationIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const defaultMenus = [
  { text: 'settlement.navigation.predictionSettlement', context: 'operation' },
  { text: 'settlement.navigation.auctionSettlement', context: 'operation' },
];

export const SubTopNavigationBar: React.FC<SubTopNavigationBarProps> = ({
  testId,
  className,
  selectedIndex,
  menus,
  setNavigationIndex,
}) => {
  const { t } = useTranslation();
  const selectedClass =
    'noto-bold-3 text-dark-6 border-b-2 border-dark-10 pt-[20px] pb-[18px]';
  const defaultClass = 'noto-normal-3 text-dark-6 py-[20px]';

  return (
    <nav data-testid={testId} className={`${className} bg-light-4`}>
      <div className="flex">
        {(menus ?? defaultMenus).map((menu, index) => {
          return (
            <div
              data-testid={`${testId}-${menu.text.split('.')[2].toLowerCase()}`}
              key={index}
              onClick={() => setNavigationIndex?.(index)}
              className={`${index === selectedIndex ? selectedClass : defaultClass} ml-[50px] flex w-fit cursor-pointer items-center justify-center px-[6px]`}
            >
              {t(menu.text, {
                context: menu.context,
              })}
            </div>
          );
        })}
      </div>
    </nav>
  );
};
